// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__2C58Y","poweredby":"Contact_poweredby__1kKLW"};